import React from "react";
import profileImg from "../assets/profileImg.jpg";
import { Award } from "react-bootstrap-icons";

export default function About() {
  return (
    <section id="about" className="py-5 section-tint">
      <div className="container">
        <div className="row mb-3">
          <div className="col-12">
            <h1 className="brand-text-dark mb-0">Sade Jones</h1>
            <p className="brand-text fw-bold">
              Psychotherapist with training in Cognitive Behavioural Therapies.
            </p>
          </div>
        </div>

        <div className="row g-4">
          <div className="col-lg-6">
            <div className="profileCard">
              <div className="profileCard-image">
                <img src={profileImg} alt="Sade" />
              </div>

              <div className="profileCard-body">
                {/* <h3 className="profileCard-name">Sade Jones</h3> */}

                <div className="profileQual-list">
                  <div className="profileQual-item">
                    <div className="profileQual-icon">
                      <Award />
                    </div>
                    <div className="profileQual-text">
                      High-intensity BABCP-accredited CBT therapist
                    </div>
                  </div>

                  <div className="profileQual-item">
                    <div className="profileQual-icon">
                      <Award />
                    </div>
                    <div className="profileQual-text">
                      Low-intensity PGDip qualification in children and young
                      people's mental health
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="aboutInfoCard">
              <p className="aboutIntro">
                I'm <strong>Sade</strong> (pronounced Shar-day), a psychotherapist
                with training in Cognitive Behavioural Therapies.
              </p>

              <p className="aboutBody">
                I have experience supporting children, young people, and adults,
                shaped by my work within NHS children’s services and adult mental
                health teams.
              </p>

              <p className="aboutBody">
                I currently work in a private hospital specialising in the
                treatment of Obsessive Compulsive Disorder (OCD), alongside my
                private practice, where I support clients with a wide range of
                difficulties such as Generalised Anxiety, Specific Phobias,
                Health Anxiety, Social Anxiety, OCD, Depression, PTSD, and
                Emetophobia.
              </p>

              <div className="aboutBlock">
                <h4 className="aboutBlock-title">Areas of focus</h4>

                <div className="focusTags">
                  <span className="focusTag">Anxiety</span>
                  <span className="focusTag">Health Anxiety</span>
                  <span className="focusTag">Social Anxiety</span>
                  <span className="focusTag">OCD</span>
                  <span className="focusTag">Depression</span>
                  <span className="focusTag">PTSD</span>
                  <span className="focusTag">Emetophobia</span>
                </div>
              </div>

              <div className="aboutBlock aboutBlock-border">
                <h4 className="aboutBlock-title">Experience</h4>

                <p className="aboutBody">
                  I have experience working within NHS IAPT services for adults,
                  as well as within CAMHS, supporting children and young people
                  with a range of mental health needs, such as confidence building
                  and managing social anxiety.
                </p>

                <p className="aboutBody mb-0">
                  I have also worked in higher education settings, providing
                  support within university services, and have held roles in
                  private hospitals specialising in the treatment of Obsessive
                  Compulsive Disorder (OCD).
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}